<template>
  <div class="principal pb-5">
    <VueSlickCarousel
      v-bind="settings"
      ref="carousel"
      @beforeChange="onBeforeChangeCarousel"
    >
      <div class="slide">
        <img
          class="image12 d-xl-none d-block"
          src="image/resource/grupo-1b.png"
        />
        <div class="backColor"></div>
        <div class="slide_img" id="one">
          <div class="caption">
            <div class="texts px-4 pb-4">
              <p class="text1">
                <b>
                  Aprende técnicas y métodos de gran valor explicados por los
                  grandes expertos del sector Médico.</b
                >
              </p>
              <p class="title1">
                <b
                  >Instructores Calificados y
                  Expertos</b
                >
              </p>
              <div class="separator1">
                <div v-if="slideIndex == 0" class="line1"></div>
                <div class="line2"></div>
              </div>
            </div>
          </div>
          <img
            class="image11 d-xl-block d-none"
            src="image/resource/grupo-1a.png"
          />
        </div>
      </div>

      <div class="slide">
        <img
          class="image12 d-xl-none d-block"
          src="image/resource/grupo-2b.png"
        />
        <div class="backColor"></div>
        <div class="slide_img" id="one">
          <div class="caption">
            <div class="texts px-4 pb-4">
              <p class="text1">
                <b
                  >Disfruta de los cursos desde casa, sin horarios ni entregas.
                  Tú marcas tu propia agenda, puedes verlos una y otra vez.</b
                >
              </p>
              <p class="title1"><b>Acceso ilimitado aprende a tu ritmo</b></p>
              <div class="separator1">
                <div v-if="slideIndex == 1" class="line1"></div>
                <div class="line2"></div>
              </div>
            </div>
          </div>
          <img
            class="image11 d-xl-block d-none"
            src="image/resource/grupo-2a.png"
          />
        </div>
      </div>
    </VueSlickCarousel>
    <div class="content-nav">
      <div class="nav_slide d-none d-xl-flex" id="nav_slide">
        <label
          for="i1"
          @click="goTo(0)"
          class="dots"
          :class="{ selected: slideIndex == 0 }"
          id="dot1"
          ><div class="selectDot"></div
        ></label>
        <label
          for="i2"
          @click="goTo(1)"
          class="dots"
          :class="{ selected: slideIndex == 1 }"
          id="dot2"
          ><div class="selectDot"></div
        ></label>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "carousel",
  components: { VueSlickCarousel },
  data() {
    return {
      counter: 1,
      slideIndex: 0,
      settings: {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        infinite: true
      }
    };
  },

  methods: {
    newSlide: function() {
      this.slideIndex = this.$refs.carousel.getCurrentSlide();
    },

    goTo(index) {
      console.log(index);
      this.slideIndex = index;
      this.$refs.carousel.goTo(index);
    },
    onBeforeChangeCarousel(oldSlideIndex, newSlideIndex) {
      this.slideIndex = newSlideIndex;
    }
  },
  created() {}
};
</script>

<style scoped>
.principal {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding-bottom: 0px !important;
}

.content-nav {
  position: relative;
}

.nav_slide {
  position: absolute;
  top: -55px;
  width: 450px;
  z-index: 99;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.image12 {
  width: 100vw;
  position: absolute;
}

.line {
  background: linear-gradient(90deg, #446daf 0%, #de337a 100%) 0% 0% no-repeat
    padding-box;
  height: 22px;
  width: 725px;
  -webkit-transform: skew(21deg);
  transform: skew(21deg);
  position: absolute;
  right: -5px;
  top: 544px;
}

.image11 {
  position: absolute;
  right: 0;
}

.backColor {
  background: #dddddd;
  width: 100%;
  position: absolute;
  height: 468px;
  z-index: -25;
}

.caption {
  position: relative;
  width: 100%;
  height: 544px;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.texts {
  margin-left: 3%;
  left: 0;
  width: 40%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: #dddddd;
  z-index: -5;
  justify-content: flex-end;
  margin-top: -20px;
}

.text1 {
  line-height: normal;
  font-weight: lighter;
  font-size: 18px;
  font-family: "Roboto", sans-serif;
  color: #011d28;
}

.title1 {
  line-height: -60px;
  font-family: "Roboto-Bold", sans-serif;
  color: #446daf;
  font-weight: bold;
  line-height: 48px;
  font-size: 37px;
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
}

.separator1 {
  margin-top: 3%;
  width: 280px;
  height: 5px;
}

.separator1 .line1 {
  border-radius: 3px;
  width: 280px;
  height: 5px;
  background: transparent linear-gradient(270deg, #f1946d 0%, #de337a 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
  position: absolute;
  animation: timing 5s linear infinite;
}

.separator1 .line2 {
  border-radius: 3px;
  width: 280px;
  height: 5px;
  background: #ffffff;
}

body,
html {
  overflow-x: hidden; /* optional */
}

#i1,
#i2,
#i3 {
  display: none;
}

.carousel #nav_slide {
  width: 40%;
  margin-left: 3%;
  bottom: 10%;
  height: 30px;
  position: absolute;
  text-align: center;
  z-index: 99;
  cursor: default;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.slide {
  position: relative;
}

.slide_img {
  z-index: -1;
  display: flex;
}

#i1:checked ~ #one,
#i2:checked ~ #two,
#i3:checked ~ #three {
  z-index: 9;
  animation: scroll 1s ease-in-out;
}

@keyframes scroll {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}

@keyframes timing {
  from {
    width: 0px;
  }

  to {
    width: 300px;
  }
}

/* *********************************** */

@media (max-width: 324px) {
  .carousel {
    margin-top: -10px;
    height: 343px !important;
  }

  .caption {
    max-height: 425px !important;
    height: 425px !important;
  }

  .backColor {
    background: #dddddd;
    width: 100%;
    position: absolute;
    z-index: -25;
  }

  .carousel .slide_img img {
    top: 20px;
    width: 100%;
    height: 196px;
  }

  .texts {
    width: 85%;
    margin-bottom: 10%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #dddddd;
    z-index: -5;
    padding-top: 30px;
  }

  .texts .text1 {
    order: 1;
    font-size: 12px;
    text-align: center;
    margin: 8px 0;
  }

  .texts .title1 {
    line-height: normal;
    font-family: "Roboto-Bold", sans-serif;
    color: #446daf;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    letter-spacing: 0px;
    opacity: 1;
    margin-bottom: 0px;
    line-height: 24px;
  }

  .separator1 {
    order: 2;
    margin-top: 3%;
    /* width: 70%; */
    width: 280px;
    height: 3px;
  }

  .carousel #nav_slide {
    display: none;
  }

  .image11 {
    display: none;
  }

  .image12 {
    display: block;
  }
}

/* ******************* */
@media (min-width: 320px) and (max-width: 574px) {
  .carousel {
    margin-top: 0px;
  }

  .caption {
    max-height: 500px;
    height: 500px;
  }

  .image12 {
    top: 64px;
  }

  .separator1,
  .line1,
  .line2 {
    max-width: 220px;
  }

  .backColor {
    background: #dddddd;
    width: 100%;
    position: absolute;
    height: 410px;
    z-index: -25;
  }

  .carousel .slide_img img {
    width: 100%;
    height: 220px;
  }

  .texts {
    width: 85%;
    margin-bottom: 7%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #dddddd;
    z-index: -5;
  }

  .texts .text1 {
    order: 1;
    font-size: 12px;
    text-align: center;
    margin: 8px 0;
  }

  .texts .title1 {
    order: 0;
    font-size: 20px;
    line-height: 24px;
  }

  .text1,
  .title1 {
    max-width: 300px;
  }

  .separator1 {
    order: 2;
    margin-top: 3%;
    /* width: 70%; */
    width: 300px;
    height: 3px;
  }

  .carousel #nav_slide {
    display: none;
  }

  .image11 {
    display: none;
  }

  .image12 {
    display: block;
  }
} /* ****************** */

/* ******************* */
@media (min-width: 575px) and (max-width: 767px) {
  .carousel {
    margin-top: 0px;
    height: 345px !important;
  }

  .caption {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .texts {
    width: 37%;
    margin-left: 3%;
    left: 0;
    display: flex;
    flex-direction: column;
    background-color: #dddddd;
    z-index: -5;
  }

  .texts .text1 {
    font-size: 18px;
    text-align: left;
    margin: 8px 0;
  }

  .texts .title1 {
    font-size: 28px;
  }

  .separator1 {
    margin-top: 3%;
    /* width: 60%; */
    width: 300px;
    height: 3px;
  }

  .carousel #nav_slide {
    display: flex;
    height: 25px;
  }

  #nav_slide .dots {
    width: 26px;
    height: 26px;
    margin: 0 18px;
  }

  .dots .selectDot {
    width: 14px;
    height: 14px;
  }

  .image11 {
    display: block;
  }

  .image12 {
    display: none;
  }
} /* ****************** */

/* ******************* */
@media (min-width: 768px) and (max-width: 1199px) {
  .image12 {
    width: 100vw;
    position: relative;
  }

  .separator1 {
    margin: auto !important;
  }

  .backColor {
    background: #dddddd;
    width: 100%;
    position: absolute;
    height: 488px;
    z-index: -25;
    margin-top: -150px;
  }

  .texts {
    margin-left: auto !important;
    margin-right: auto !important;
    width: 600px !important;
    margin-top: -200px;
    text-align: center;
    justify-content: center;
  }

  .title1 {
    text-align: center !important;
  }

  .text1 {
    text-align: center !important;
    font-size: 16px;
  }

  .caption {
    height: 400px !important;
  }

  .backColor {
    height: 400px !important;
  }
}
@media (min-width: 1440px) {
  .nav_slide {
    width: 600px;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .carousel {
    margin-top: 0px;
    height: 345px !important;
  }

  .nav_slide {
    width: 300px;
  }

  .caption {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .texts {
    width: 36%;
    margin-left: 3%;
    left: 0;
    display: flex;
    flex-direction: column;
    background-color: #dddddd;
    z-index: -5;
  }

  .texts .text1 {
    text-align: left;
    margin: 8px 0;
  }

  .texts .title1 {
    font-size: 28px;
  }

  .separator1 {
    margin-top: 3%;
    width: 300px;
    height: 3px;
  }

  .carousel #nav_slide {
    display: flex;
    height: 25px;
  }

  #nav_slide .dots {
    width: 26px;
    height: 26px;
    margin: 0 20px;
  }

  .dots .selectDot {
    width: 14px;
    height: 14px;
  }

  .image11 {
    display: block;
  }

  .image12 {
    display: none;
  }

  .lineah {
    background: linear-gradient(90deg, #446daf 0%, #de337a 100%) 0% 0% no-repeat
      padding-box;
    height: 22px;
    margin: 0px;
    align-self: center;
    transform: skew(21deg);
  }

  .p-line {
    padding-left: 50%;
  }
} /* ****** */

@media (min-width: 1024px) and (max-width: 1439px) {
  .carousel {
    margin-top: 0px;
    height: 490px !important;
  }

  .text1 {
    margin-top: 20px !important;
  }

  .caption {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .texts {
    width: 35%;
    /* height: 240px; */
    margin-left: 3%;
    left: 0;
    display: flex;
    flex-direction: column;
    background-color: #dddddd;
    z-index: -5;
  }

  .texts .text1 {
    font-size: 20px;
    text-align: left;
    margin: 8px 0;
  }

  .texts .title1 {
    font-size: 37px;
  }

  .separator1 {
    margin-top: 3%;
    /* width: 60%; */
    width: 300px;
    height: 5px;
  }

  /* .title{
  width: 30%;
} */

  .carousel #nav_slide {
    display: flex;
    height: 30px;
  }

  #nav_slide .dots {
    width: 30px;
    height: 30px;
    margin: 0 30px;
  }

  .dots .selectDot {
    width: 18px;
    height: 18px;
  }

  .image11 {
    display: block;
  }

  .image12 {
    display: none;
  }

  .lineah {
    background: linear-gradient(90deg, #446daf 0%, #de337a 100%) 0% 0% no-repeat
      padding-box;
    height: 22px;
    margin: 0px;
    align-self: center;
    transform: skew(21deg);
  }

  .p-line {
    padding-left: 50%;
  }
}

@media (min-width: 1199px) {
  .text1 {
    width: calc(100% - 100px);
  }
}

@media (max-width: 1199px) {
  .text1 {
    width: 100%;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .principal {
    margin-top: -20%;
  }
}

@media (min-width: 1440px) and (max-width: 2559px) {
  .carousel {
    margin-top: 0px;
    height: 544px !important;
    width: 1440px;
  }

  .caption {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .texts {
    width: 40%;
    height: 50%;
    margin-left: 3%;
    left: 0;
    display: flex;
    flex-direction: column;
    background-color: #dddddd;
    z-index: -5;
  }

  .texts .text1 {
    font-size: 18px;
    text-align: left;
    margin: 25px 0;
  }

  .texts .title1 {
    font-size: 37px;
  }

  .separator1 {
    margin-top: 3%;
    /* width: 60%; */
    width: 300px;
    height: 5px;
  }

  .carousel #nav_slide {
    display: flex;
    height: 30px;
  }

  #nav_slide .dots {
    width: 30px;
    height: 30px;
    margin: 0 30px;
  }

  .dots .selectDot {
    width: 18px;
    height: 18px;
  }

  .image11 {
    display: block;
  }

  .image12 {
    display: none;
  }

  .lineah {
    background: linear-gradient(90deg, #446daf 0%, #de337a 100%) 0% 0% no-repeat
      padding-box;
    height: 22px;
    margin: 0px;
    align-self: center;
    transform: skew(21deg);
  }

  .p-line {
    padding-left: 50%;
  }
}

@media (min-width: 2560px) {
  .carousel {
    margin-top: 0px;
    height: 545px !important;
    width: 1440px;
  }

  .caption {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .texts {
    width: 35%;
    margin-left: 3%;
    left: 0;
    display: flex;
    flex-direction: column;
    background-color: #dddddd;
    z-index: -5;
  }

  .texts .text1 {
    font-size: 18px;
    text-align: left;
    margin: 8px 0;
  }

  .texts .title1 {
    font-size: 37px;
  }

  .separator1 {
    margin-top: 3%;
    /* width: 60%; */
    width: 300px;
    height: 5px;
  }

  .carousel #nav_slide {
    display: flex;
    height: 30px;
  }

  #nav_slide .dots {
    width: 30px;
    height: 30px;
    margin: 0 30px;
  }

  .dots .selectDot {
    width: 18px;
    height: 18px;
  }

  .image11 {
    display: block;
  }

  .image12 {
    display: none;
  }

  .lineah {
    background: linear-gradient(90deg, #446daf 0%, #de337a 100%) 0% 0% no-repeat
      padding-box;
    height: 22px;
    margin: 0px;
    align-self: center;
    transform: skew(21deg);
  }

  .p-line {
    padding-left: 50%;
  }
}

@media only screen and (max-width: 767px) {
  .sub-menu-overlay {
    top: 64px !important;
    height: 100vh !important;
  }

  .text1 {
    max-width: 350px;
  }

  .texts {
    width: 100vw;
    margin-left: 0px;
    height: 150px;
  }

  .texts .title1 {
    line-height: 24px;
    text-align: center;
  }
}

/* slick  */
::v-deep .slick-dots {
  position: absolute;
  bottom: 25px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  left: 242px;
  list-style: none;
  text-align: center;
  width: fit-content;
}

#nav_slide .dots {
  padding: 2px;
  width: 30px;
  height: 30px;
  margin: 0 30px;
  border-radius: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.dots .selectDot {
  cursor: pointer;
  width: 18px;
  height: 18px;
  border-radius: 100%;
  background-color: #446daf;
}

.selected {
  border: 3px solid #de337a;
}
</style>
